import Commons from '../../../../Services/Common/Common';

export const AI_BASIC_Schema = {
  fields: {
    grid: {
      aiMessageCd: { initial: '', label: '보이스 체크 코드' },
      message: {
        initial: '',
        label: '보이스 체크 내용',
        required: 'Y',
        message: '보이스 체크 내용은 필수 입력 항목입니다.',
        type: 'error',
      },
      seq: { initial: '', label: '순서' },
      gubun: { initial: '', label: '구분' }, // 0: 종료, 1: 에러, 2: 질문
    },
  },

  mapper: {
    search1: {
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd || ''),
      UserId: (_, context) => context.userInfo?.userid,
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText),
    },
    search2: {
      CustCd: (_, context) =>
        Commons.EncryptAES(context.search?.custCd || '') || '',
      StartDate: (_, context) =>
        Commons.EncryptAES(context.search?.startDate || '') || '',
      EndDate: (_, context) =>
        Commons.EncryptAES(context.search?.endDate || '') || '',
      SearchText: (_, context) =>
        Commons.EncryptAES(context.search?.searchText || '') || '',
    },
    save1: {
      AiMessageCd: (row) => Commons.EncryptAES(row.aiMessageCd || ''),
      Message: (row) => Commons.EncryptAES(row.message || ''),
      OrgSeq: (row) => Commons.EncryptAES(row.seq?.toString() || ''),
      ChangeSeq: (row) => Commons.EncryptAES(row.no?.toString() || ''),
      Gubun: (row) => Commons.EncryptAES(row.gubun || '2'),
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd || ''),
      UserId: (_, context) => context.userInfo?.userid,
    },
    save2: {
      CustCd: (_, context) => Commons.EncryptAES(context.search?.custCd || ''),
    },
    delete1: {
      CustCd: (row) => Commons.EncryptAES(row.custCd || ''),
      AiMessageCd: (row) => Commons.EncryptAES(row.aiMessageCd || ''),
    },
  },
};
